import React, { useState } from 'react';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { isNotEmpty } from '../../utils';

export const Description = ({
    name,
    styles,
    classNameWrapper,
    className,
    variant,
    label,
    maxLength,
    disabled,
    allowCharacter = false,
    noError,
    error,
    value,
    handleChange,
}) => {
    const [isFocused, toggleFocus] = useState(false);

    return (
        <div className={`main-textarea-wrapper ${classNameWrapper ? classNameWrapper : ''}`}>
            {label && <p className={`main-textarea-label ${isFocused || value ? 'active-label' : ''}`}>{label}</p>}
            <TextareaAutosize
                style={{ ...styles }}
                className={`main-textarea-box ${!!error ? 'error-textarea-box' : ''} ${className ? className : ''}`}
                variant={variant}
                name={name}
                label={label}
                id="standard-basic"
                onFocus={() => toggleFocus(true)}
                onBlur={() => toggleFocus(false)}
                error={!!error}
                onChange={handleChange}
                value={isNotEmpty(value) ? value : ''}
                disabled={disabled}
                maxLength={maxLength}
                multiline
            />
            {allowCharacter && (
                <p className="allow-character">
                    {value?.length || 0}/{maxLength} characters
                </p>
            )}

            {!noError && <p className="error-message">{error}</p>}
        </div>
    );
};
